import { GridFooterContainer } from '@mui/x-data-grid';
import { componentSizes } from '@/theme/componentSizes';
import { Box, Skeleton } from '@/ui/primitives';
import { s } from '../../../theme/tokens';
import type { ReactElement } from 'react';

const TABLE_SKELETON_FOOTER_WIDTH = '380px';
const TABLE_SKELETON_RADIUS = '999px';

export const SkeletonPaginationFooter = (): ReactElement => (
  <GridFooterContainer>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
        height: `${componentSizes.dataGrid.footerHeight}px`,
        minHeight: `${componentSizes.dataGrid.footerHeight}px`,
        maxHeight: `${componentSizes.dataGrid.footerHeight}px`,
        boxSizing: 'border-box',
        px: s('md'),
        py: 0,
      }}
    >
      <Skeleton
        variant="rounded"
        width={TABLE_SKELETON_FOOTER_WIDTH}
        height="14px"
        sx={{ transform: 'none', borderRadius: TABLE_SKELETON_RADIUS }}
      />
    </Box>
  </GridFooterContainer>
);
